export enum GradeLevel {
	NONE = 20,
	PK = 1,
	KG = 2,
	FIRST = 3,
	SECOND = 4,
	THIRD = 5,
	FOURTH = 6,
	FIFTH = 7,
	SIXTH = 8,
	SEVENTH = 9,
	EIGHTH = 10,
	NINTH = 11,
	TENTH = 12,
	ELEVENTH = 13,
	TWELFTH = 14
}

export const Grades: GradeLevel[] = [];
for (let i = GradeLevel.PK; i <= GradeLevel.TWELFTH; i++) {
	Grades.push(i);
}
